
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import OCROrderApi from "@/api/ocr-order-api";
import UploadApi from "@/api/upload-api";
import OcrOrder from "./config";
import ItemEditor from "./item-editor.vue";
// import ItemEditorCustom from "./item-editor-custom.vue";
import { Row, Toast } from "vant";
import { StyleHTMLAttributes, StyleValue } from "vue";
import filter from "@/utils/filter";

type ImgFile = UploadApi.IFileDetailView & { url: string }
type MainType = OCROrderApi.IOcrOrderReceiptItem
type OrderType = OcrOrder.IOcrOrderListItemWithDetail;
enum SortMethod {
    none = 0,
    default = 1,
    asc = 2,
    desc = 3
}
type TableColumn = {
    title: string; key: "Amount" | keyof MainType, cssClass?: string | string[] | ((m: MainType) => string), headStyle?: StyleValue, sortMethod?: SortMethod,
    valueFormatter?: (m: MainType, col: TableColumn) => any
};

@Component({ name: "item-view", components: { ItemEditor } })
export default class ItemView extends Vue {
    popup = { tradeIndex: false, tradeIndexItem: {} as MainType }
    lastOrderByColums: TableColumn = {} as any
    sortClick(column: TableColumn) {
        if (!column.sortMethod) return;
        if (column != this.lastOrderByColums) this.lastOrderByColums.sortMethod = SortMethod.default;
        var s = column.sortMethod % 3 + 1;
        column.sortMethod = s;
        this.lastOrderByColums = column;
    }

    @Prop({ required: true }) datasource!: MainType[]


    get sortedData() {
        if (!this.lastOrderByColums.sortMethod || this.lastOrderByColums.sortMethod === SortMethod.default) return this.datasource;
        const key = this.lastOrderByColums.key;//as keyof MainType;
        const sm = this.lastOrderByColums.sortMethod;

        const sortedArray = [...this.datasource].sort((a, b) => {
            if (key == "Amount") {
                const va = (Number(a.Qty) * Number(a.RefPrice)) || 0;
                const vb = (Number(b.Qty) * Number(b.RefPrice)) || 0;
                return sm === SortMethod.asc ? va - vb : vb - va;
            }
            const valA = a[key] as string | number | undefined;
            const valB = b[key] as string | number | undefined;
            if (typeof valA === 'number' && typeof valB === 'number') {
                return sm === SortMethod.asc ? valA - valB : valB - valA;
            }
            const strA = String(valA || '');
            const strB = String(valB || '');
            return sm === SortMethod.asc ? strA.localeCompare(strB) : strB.localeCompare(strA);
        });
        return sortedArray;
    }

    // 定义表格列
    columns: TableColumn[] = [
        { title: '型号', key: "PartNo", },
        { title: '品牌', key: "Brand" },
        { title: '数量', key: "Qty", sortMethod: SortMethod.default, cssClass: 't-r' },
        // { title: '晶圆地', key: 'RegionName' },
        { title: '产地', key: 'RegionName' },
        { title: '品类', key: "Category" },
        { title: '封装', key: 'Package' },
        { title: '年份', key: 'DateCode' },
        { title: '参考价', key: 'RefPrice', sortMethod: SortMethod.default, cssClass: 't-r' },
        { title: '预估货值', key: 'Amount', sortMethod: SortMethod.default, cssClass: 't-r' },
        { title: '30天搜索次数', key: 'BomAiSearchIndex', sortMethod: SortMethod.default },
        { title: '交易指数', key: "TradeFrequency" },
        { title: '箱号', key: 'CaseNo' },
        { title: '货架', key: 'PalletNo' },
        { title: '备注', key: 'Remark' },
    ];


    onClick(m: MainType, column: TableColumn) {
        switch (column.key) {
            case "TradeFrequency": this.tradeIndex(m); break;
            default: this.$emit("onclick", m, column); break;
        }
    }

    tradeIndex(m: MainType) {
        this.popup.tradeIndex = true;
        this.popup.tradeIndexItem = m;
    }
    valueFormatter(m: MainType, col: TableColumn) {
        if (col.valueFormatter) return col.valueFormatter(m, col)
        switch (col.key) {
            case "Amount":
                var q = (Number(m.Qty) * Number(m.RefPrice)) || 0;
                if (!q) return "-";
                return filter.currencyText(q);
            case "Qty":
                return filter.numberText(m.Qty);

        }
        return m[col.key as keyof MainType] || "-"
    }

}
